module.exports = __webpack_public_path__ + "assets/img/29.852a6239.png";